import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import Button from '@mui/material/Button';
import { FC } from 'react';

type BoostButtonElementProps = {
  onClick: () => void;
};

const BoostButtonElement: FC<BoostButtonElementProps> = ({ onClick }) => {
  return (
    <Button
      variant="contained"
      size="small"
      startIcon={
        <RocketLaunchOutlinedIcon sx={{ fontSize: '12px !important' }} />
      }
      onClick={onClick}
      color="lightPurple"
      sx={{
        width: { xs: '100%' },
        fontSize: '12px',
        padding: '5px !important',
      }}
    >
      Boost My Jobs
    </Button>
  );
};

export default BoostButtonElement;
